var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCsvExport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11 0a1 1 0 0 1 1 1v4h-.472c-.615 0-1.163.277-1.528.713V2H2v10h7.536v1.008c0 .362.096.7.264.993L1 14a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm1.039 6L15.5 9.321a.898.898 0 0 1 0 1.358L12.039 14h-.509a.99.99 0 0 1-.992-.992V12.5l2.134-1.5H6V9h6.672l-2.134-1.5v-.508A.99.99 0 0 1 11.53 6zM5 9v2H3V9zm4-3v2H6V6zM5 6v2H3V6zm0-3v2H3V3zm4 0v2H6V3z"
})));
export default SvgCsvExport;